import { IDictionary } from "@/shared/models/interface/dictionary-model";
import { IFixedFilter } from "@/shared/models/view/fixed-filter-model";
import { Query, VUwebSearchService } from "@/shared/services/azure-search-service";
import { VUResultsMapper as VUResultsMapper } from "../../mappings/vuweb-search-response-mapper";
import { IFilterItem } from "../../models/filter-item-model";
import { IVUSearchIndexModel } from "../../models/vu-search-index-model";
import { ISearchSettings } from "../../models/search-settings-model";
import { VUFilterQueryService } from "./filter-query-service";
import { BaseSearchService } from "../base-search-service";

export class VUSearchService extends BaseSearchService<IVUSearchIndexModel> {
    readonly azureService!: VUwebSearchService;
    readonly mapper!: VUResultsMapper;

    constructor(config: ISearchSettings) {
        super();

        this.azureService = new VUwebSearchService(config.index, config.endpoint);
        this.mapper = new VUResultsMapper();
    }

    public setFilterQuery(fixedFilters: IDictionary<IFixedFilter>, scopes: IFilterItem[], filters: IDictionary<IFilterItem[]>): void {
        this.filterQuery = new VUFilterQueryService()
            .addFixedFilter(fixedFilters)
            .addScopesFilter(scopes)
            .addUserFilter(filters)
            .filter;
    }

    public setSearchQuery(order: string, query: string, skip: number, limit: number): void {
        this.searchQuery = new Query()
            .SetCount(true)
            .SetFacets(['Filter, count: 1000', 'ImplicitFilter, count: 1000'])
            .SetFilter(this.filterQuery)
            .SetHighlight('IntroText')
            .SetHighlightTag('<b>', '</b>')
            .SetOrderBy(order)
            .SetScoringProfile('BoostTitle')
            .SetSearch(query ? query.trim() : '')
            .SetSkip(skip)
            .SetTop(limit);
    }
}
